import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class TastyfxTokens {
  accountSecurityToken = ""
  authenticationStatus = ""
  clientSecurityToken = ""
}

export enum TASTYFX_AUTHENTICATION_STATUS {
  INCOMPLETE = "ONBOARDING_INCOMPLETE",
  AUTHENTICATED = "AUTHENTICATED",
}

export const TASTYFX_TOKENS_DESER: SchemaDeSer<TastyfxTokens> =
  new SchemaDeSerBuilder(TastyfxTokens)
    .ofString("clientSecurityToken", "client-security-token")
    .ofString("accountSecurityToken", "account-security-token")
    .ofString("authenticationStatus", "authentication-status")
    .toDeSer()
